const ForgotPasswordEmailSent = ({ email }: { email: string }) => (
    <>
        <p className="p-4 text-secondary">A link to reset your password has been sent to {email}</p>
    </>
);

export default ForgotPasswordEmailSent;
